import { TransformRule, TransformRuleData } from "./TransformRule";

export { ReplaceAll, ReplaceAllData };

type ReplaceAllData = {
  findPattern: string;
  replaceText: string;
} & TransformRuleData;

class ReplaceAll extends TransformRule {
  findPattern: string;
  replaceText: string;

  constructor(data: ReplaceAllData) {
    super(data);
    this.findPattern = data.findPattern;
    this.replaceText = data.replaceText;
  }

  getDlfVariables() {
    return super._getDlfVariables(this.replaceText);
  }

  getVariables() {
    return super._getVariables(this.replaceText);
  }

  isConfigured(): boolean {
    return this.findPattern.length > 0;
  }

  getRuleId(): string {
    return `${this.getDiscriminator()}-${this.fieldName}-${this.position}-${this.replaceText}-${this.findPattern}`;
  }

  toData(): ReplaceAllData {
    return {
      discriminator: this.discriminator,
      fieldName: this.fieldName,
      position: this.position,
      findPattern: this.findPattern,
      replaceText: this.replaceText,
    };
  }

  static createTest(rest: Partial<ReplaceAllData> = {}): ReplaceAll {
    const data: ReplaceAllData = {
      discriminator: "T_REPALL",
      fieldName: "",
      position: 0,
      findPattern: "",
      replaceText: "",
    };

    return new ReplaceAll({
      ...data,
      ...rest,
    });
  }
}
